<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<br/><p style="text-indent:00em;">A.F. Mitchell has spent many years immersing herself in the fantasy world; she has a big imagination and loves creating characters and how, through hard work and dedication, everything evolves.</p>
<br/><p style="text-indent:00em;">She wanted to prove to herself and others that even though she didn’t feel educated enough, she could still achieve her dream of becoming an author. She wanted to write a novel that was easy to read and that her readers would fall in love with the narrative and characters, more so than her grammar and punctuation.</p>
<br/><p style="text-indent:00em;">She lives in Radstock, Somerset, with her husband and<br/>
their daughter.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?3d635751